export class CheckVersion {
  static readonly type = '[Version] Check Version';
}
